import router from "./router";
import store from "./store";
export default {
  store,
  router
};
